var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.351,
    height: 16.395,
    viewBox: "0 0 15.351 16.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#20253a;stroke:#20253a;stroke-width:0.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.163 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.346,9.937s0,.005,0,.008l-.419,2.948a.27.27,0,0,0,.391.277L20.958,11.8h0c.007,0,.01-.011.017-.015a.266.266,0,0,0,.08-.068L26.3,4.329a1.634,1.634,0,1,0-2.666-1.892L18.39,9.827A.266.266,0,0,0,18.346,9.937ZM23.315,3.82,25.1,5.087l-4.329,6.1L18.986,9.919Zm-4.783,8.631.283-1.992,1.5,1.068Zm5.542-9.7A1.095,1.095,0,0,1,25.86,4.017l-.447.63L23.626,3.38Z",
    transform: "translate(-12.593 -1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.08,19.314A7.512,7.512,0,0,0,17.047,8.085a.27.27,0,0,0-.462.278,6.973,6.973,0,1,1-4.553-3.231.27.27,0,0,0,.11-.528A7.512,7.512,0,0,0,9.08,19.314Z",
    transform: "translate(-3.098 -3.477)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDark);
export default __webpack_public_path__ + "static/media/edit_dark.a4c71a4beb1957b1da3e02174dcef40a.svg";
export { ForwardRef as ReactComponent };